export const licenses = {
  'app.local.arsa.dev': {
    endpoint: 'localhost:8970',
    primaryColor: '#0b5a5d',
  },
  'erp.numismaticabarcala.com': {
    endpoint: 'erp-api.numismaticabarcala.com',
    primaryColor: '#5B0E2D',
  },
  'erp-priv.numismaticabarcala.com': {
    endpoint: 'erp-priv-api.numismaticabarcala.com',
    primaryColor: '#023E46',
  },
};
